import { getRolePermissionByRoleId, getRolePermissionList } from 'api/permission'

const getDefaultState = () => {
  return {
    codes: []
  }
}
const state = getDefaultState()

const mutations = {
  SET_CODE: (state, codes) => {
    state.codes = codes
  }
}

const actions = {
  getRolePermissionList({ commit }, param) {
    return new Promise((resolve, reject) => {
      getRolePermissionList(param).then(res => {
        commit('SET_CODE', res.data)
        resolve()
      }).catch(e => {
        reject(e)
      })
    })
  },
  getRolePermissionByRoleId({ commit }, roleId) {
    const id = roleId
    return new Promise((resolve, reject) => {
      getRolePermissionByRoleId(id).then(res => {
        commit('SET_CODE', res.data)
        resolve()
      }).catch(e => {
        reject(e)
      })
    })
  }
}

export default {
  state,
  mutations,
  actions
}